import React, { useEffect } from 'react';
import './modal.css';

export default function Modal({ show, onClose }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' || event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Congratulations, you have saved the world from the wizard! You are a hero!!!</h2>
        <button onClick={onClose}>Enter / Esc</button>
      </div>
    </div>
  );
}
